import { render, staticRenderFns } from "./PositionPageHeader.vue?vue&type=template&id=06d96778&scoped=true"
import script from "./PositionPageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionPageHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionPageHeader.vue?vue&type=style&index=0&id=06d96778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d96778",
  null
  
)

export default component.exports